import React from 'react'
import { Col, Row } from 'react-bootstrap';
import DeviceDataByDay from '../../admin_dashboard/DeviceDataByDay';
import MAUByLocationsStatus from '../../admin_dashboard/MAUByLocationsStatus';
import DeviceByOs from '../../admin_dashboard/metrics/DeviceByOs';
import GeolocatedDeviceByOs from '../../admin_dashboard/metrics/GeolocatedDeviceByOs';
import LocationOptInByOs from '../../admin_dashboard/metrics/LocationOptInByOs';
import LocationStatus from '../../admin_dashboard/metrics/LocationStatus';


const AdminDashboardDeviceTab = ({filter}) => {
  return (<>
    <DeviceDataByDay filter={filter}/>
    <Row>
      <Col>
        <DeviceByOs filter={filter} />
      </Col>
      <Col>
        <GeolocatedDeviceByOs filter={filter} />
      </Col>
      <Col>
        <LocationOptInByOs filter={filter} />
      </Col>
    </Row>
    <Row>
      <Col>
        <LocationStatus filter={filter} />
      </Col>
      <Col>
        <MAUByLocationsStatus filter={filter}/>
      </Col>
    </Row>
  </>)
}

export default AdminDashboardDeviceTab;